<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/schedule')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="validateRegister">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Branch</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="branch" v-model="branch_id" @change="changeBranch">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="status">Studio</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="studio" v-validate="'required'" @change="changeTimeAndClass" v-model="addData.studio_id">
                    <option :value="null">Please select</option>
                    <option v-for="item in optStudio" :value="item.id" :key="item.id">{{item.name}}</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('studio') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="status">Classes Name</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="classes_name" v-validate="'required'" v-model="addData.classes_id">
                    <option :value="null">Please select</option>
                    <option v-for="item in optClasses" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('classes_name') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="status">Time</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="time" v-validate="'required'" v-model="addData.classes_time_id">
                    <option :value="null">Please select</option>
                    <option v-for="item in optClassesTime" :key="item.id" :value="item.id">{{item.time_start}} - {{item.time_end}}</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('time') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="status">Coach</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="coaches" v-validate="'required'" v-model="addData.coaches_id">
                    <option :value="null">Please select</option>
                    <option v-for="item in optCoaches" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('coaches') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="schedule">Total Seat</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="addData.total_seat" name="seat" v-validate="'required|numeric'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('seat') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="status">Day</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="day" v-validate="'required'" v-model="addData.classes_days_id">
                    <option :value="null">Please select</option>
                    <option v-for="item in optClassesDay" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('day') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Virtual Class</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <b-form-select name="virtual_class" v-validate="'required'" v-model="addData.virtual_class_status" :options="options" class="mb-3" />
                  </div>
                  <span class="error">{{ errors.first('virtual_class') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="status">Status</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <b-form-select name="status" v-validate="'required'" v-model="addData.status" :options="options2" class="mb-3" />
                  </div>
                  <span class="error">{{ errors.first('status') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="schedule">IP Address</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="addData.ip_address" name="ip_address" v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('ip_address') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="is_special">Special</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <b-form-select name="is_special" v-validate="'required'" v-model="addData.is_special" :options="options3" class="mb-3" />
                  </div>
                  <span class="error">{{ errors.first('is_special') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="is_special">New</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <b-form-select name="is_new" v-validate="'required'" v-model="addData.is_new" :options="options3" class="mb-3" />
                  </div>
                  <span class="error">{{ errors.first('is_new') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="is_cancel">Cancel</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <b-form-select name="is_cancel" v-validate="'required'" v-model="addData.is_cancel" :options="options3" class="mb-3" />
                  </div>
                  <span class="error">{{ errors.first('is_cancel') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="address">Is Disable</label>
                </b-col>
                <b-col sm="10">
                  <toggle-button v-model="addData.is_disable_booking" name="is_disable" :sync="true"/>
                  <span class="error">{{ errors.first('is_disable') }}</span>
                </b-col>
              </b-row>
              <div class="text-right">
                <button type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'

export default {
  name: 'addSchedule',
  data: function () {
    return {
      dataBranch: [],
      branch_id: null,
      addData: {
        classes_id: null,
        coaches_id: null,
        classes_time_id: null,
        studio_id: null,
        total_seat: '',
        classes_days_id: null,
        virtual_class_status: null,
        status: null,
        ip_address: null,
        is_special: null,
        is_new: null,
        is_cancel: null,
        is_disable_booking: false
      },
      options: [
        { value: null, text: 'Please select' },
        { value: 'yes', text: 'Yes' },
        { value: 'no', text: 'No' }
      ],
      options2: [
        { value: null, text: 'Please select' },
        { value: 'active', text: 'Active' },
        { value: 'inactive', text: 'Inactive' }
      ],
      options3: [
        { value: null, text: 'Please select' },
        { value: '1', text: 'Yes' },
        { value: '0', text: 'No' }
      ],
      optClasses: [],
      optCoaches: [],
      optClassesTime: [],
      optClassesDay: [],
      optStudio: []
    }
  },
  methods: {
    validateRegister () {
      this.$validator.validateAll().then((result) => {
        if(result) {
          axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
          axios.post('fitness/v1/classes_schedule', this.addData).then(response => {
            // console.log('test', response)
            this.$router.push('/schedule')
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            // console.log('error', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    changeBranch(event) {
      axios.get('fitness/v1/studio?branch_id=' + event).then(response => {
        this.optStudio = response.data.data.rows
        this.studio_id = null
      }).catch(error => {
        console.log('error', error)
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    previewImage: function(event) {
        // Reference to the DOM input element
        var input = event.target;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
            // create a new FileReader to read this image and convert to base64 format
            var reader = new FileReader();
            // Define a callback function to run, when FileReader finishes its job
            reader.onload = (e) => {
                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                // Read image as base64 and set to imageData
                this.imageData = e.target.result;
            }
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
        }
    },
    changeTimeAndClass (event) {
      // console.log(event)
      axios.get('fitness/v1/classes_time/' + event  + '?sorting=time_start&sorting_type=asc').then(response => {
        this.optClassesTime = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/classes?studio_id=' + event).then(response => {
        this.optClasses = response.data.data.rows
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
    },
    fetchData () {
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      axios.get('fitness/v1/coaches?status=active&sorting=name&sorting_type=asc').then(response => {
        this.optCoaches = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('fitness/v1/classes?studio_id=' + event).then(response => {
        this.optClasses = response.data.data.rows
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('fitness/v1/studio?sorting=id&sorting_type=asc').then(response => {
        this.optStudio = response.data.data.rows
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('fitness/v1/classes_days?sorting=id&sorting_type=asc').then(response => {
        this.optClassesDay = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
